import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PointOfDelivery } from '../models/point-of-delivery.model';

@Injectable({
  providedIn: 'root',
})
export class RequestCpeService {
  constructor(protected _http: HttpClient) {}

  getDistricts(args): Observable<any> {
    const url = `/listeners/ms/assets/areas/districts/get-all`;

    return this._http.post(url, args).pipe(
      map((response: any) => {
        if (response.Body.Success) {
          return response.Body.Result;
        }
      })
    );
  }

  getCounties(args): Observable<any> {
    const url = `/listeners/ms/assets/areas/counties/get-all`;

    return this._http.post(url, args).pipe(
      map((response: any) => {
        if (response.Body.Success) {
          return response.Body.Result;
        }
      })
    );
  }

  getParishes(args): Observable<any> {
    const url = `/listeners/ms/assets/areas/parishes/get-all`;

    return this._http.post(url, args).pipe(
      map((response: any) => {
        if (response.Body.Success) {
          return response.Body.Result;
        }
      })
    );
  }

  getStreets(args, code): Observable<any> {
    const url = `/listeners/ms/masterdata/point-of-delivery/street/${code}/get-all`;

    return this._http.post(url, args).pipe(
      map((response: any) => {
        if (response.Body.Success) {
          return response.Body.Result;
        }
      })
    );
  }

  /**
   * This function sends a POST request to a specific URL with given arguments and returns the
   * response.
   * @param args - It is a parameter that is being passed to the `getFloors` function. It is not clear
   * from the code snippet what the `args` parameter is or what it contains. It could be any data that
   * is required for the HTTP POST request being made to the specified URL.
   * @param code - The `code` parameter is a string that represents the code of a point of delivery
   * fraction. It is used in the URL to make a POST request to retrieve all floors associated with that
   * fraction.
   * @returns The `getFloors` function returns an Observable that makes a POST request to a specific
   * URL with some arguments and returns the response as an Observable. The response is mapped to
   * return the entire response object.
   */
  getFloors(args): Observable<any> {
    const url = '/listeners/ms/masterdata/point-of-delivery/fraction/get-all';

    return this._http.post(url, args).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  /**
   * It takes an object as an argument, makes a post request to the server, and returns an array of
   * pods details.
   * </code>
   * @param args
   * @returns An Observable of PointOfDelivery[]
   */
  getFractions(args): Observable<PointOfDelivery[]> {
    const url = `/listeners/ms/masterdata/point-of-delivery/details`;

    return this._http.post(url, args).pipe(
      map((response: any) => {
        if (response.codeDetail) {
          return response.contentResponse.pods;
        }
      })
    );
  }

  getCounters(args): Observable<any> {
    const url = `/listeners/ms/masterdata/manufacturer/get-all`;

    return this._http.post(url, args).pipe(
      map((response: any) => {
        if (response) {
          return response;
        }
      })
    );
  }

  getCpe(args): Observable<any> {
    const url = `/listeners/ms/masterdata/cpe/search`;

    return this._http.post(url, args).pipe(
      map((response: any) => {
        if (response.Body.Success) {
          return response.Body.Result;
        }
      })
    );
  }
}
